// The one place the AI services consent gate lives.
//
// The version string is the whole mechanism: bumping it is what re-prompts
// every drafter the next time the terms change. A second copy of it means one
// entry point re-prompts and the other keeps running against consent nobody
// re-gave, and the two only diverge at the moment the bump is supposed to
// matter. design §11f says the deal-terms flow "already exists ... and must be
// wired in here" — so the import enrichment shares this service rather than
// carrying its own copy of the constant, the modal and the acceptance call.
angular.module('LeasePilot').factory('AiServicesConsentService', [
  '$q',
  '$rootScope',
  '$mdDialog',
  'ApiService',
  function($q, $rootScope, $mdDialog, ApiService) {
    const AI_SERVICES_CONSENT_VERSION = 'LP-AI-SERVICES-2026-05';

    function hasAcceptedAiServicesConsent() {
      const profile =
        ($rootScope.user &&
          ($rootScope.user.userProfile || $rootScope.user.user_profile)) ||
        {};
      const acceptedAt =
        profile.aiServicesConsentAcceptedAt ||
        profile.ai_services_consent_accepted_at;
      const acceptedVersion =
        profile.aiServicesConsentVersion || profile.ai_services_consent_version;

      return acceptedAt && acceptedVersion === AI_SERVICES_CONSENT_VERSION;
    }

    function showAiServicesConsentDialog() {
      return $mdDialog.show({
        templateUrl: 'ai_services_consent_modal.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        controller: [
          '$scope',
          '$mdDialog',
          function(dialogScope, dialog) {
            dialogScope.accept = function() {
              dialog.hide();
            };
            dialogScope.cancel = function() {
              dialog.cancel();
            };
          },
        ],
      });
    }

    // Resolves once consent for the current version is on record, rejects if
    // the drafter declines. $q rather than a native promise so callers continue
    // inside the digest that follows.
    function ensureAiServicesConsent() {
      if (hasAcceptedAiServicesConsent()) {
        return $q.when();
      }

      return showAiServicesConsentDialog().then(function() {
        return ApiService.acceptAiServicesConsent(
          AI_SERVICES_CONSENT_VERSION,
        ).then(function(response) {
          const user = response.data || $rootScope.user || {};
          user.userProfile = user.userProfile || user.user_profile || {};
          user.userProfile.aiServicesConsentAcceptedAt =
            user.userProfile.aiServicesConsentAcceptedAt ||
            user.userProfile.ai_services_consent_accepted_at ||
            new Date().toISOString();
          user.userProfile.aiServicesConsentVersion = AI_SERVICES_CONSENT_VERSION;
          $rootScope.user = user;
          window.user = user;
        });
      });
    }

    return {
      AI_SERVICES_CONSENT_VERSION: AI_SERVICES_CONSENT_VERSION,
      hasAcceptedAiServicesConsent: hasAcceptedAiServicesConsent,
      ensureAiServicesConsent: ensureAiServicesConsent,
    };
  },
]);
